import aboutCardIcon1 from "../images/icon/aboutus_card_icon1.svg";
import aboutCardIcon2 from "../images/icon/aboutus_card_icon2.svg";
import aboutCardIcon3 from "../images/icon/aboutus_card_icon3.svg";
import aboutCardIcon4 from "../images/icon/aboutus_card_icon4.png";
import aboutCardIcon5 from "../images/icon/aboutus_card_icon5.png";
import aboutCardIcon6 from "../images/icon/aboutus_card_icon6.png";

const data = [
  {
    icon: aboutCardIcon4,
    title: "NFT Breeding",
    text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.",
  },
  {
    icon: aboutCardIcon5,
    title: "Staking",
    text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.",
  },
  {
    icon: aboutCardIcon6,
    title: "Reward Ecosystem",
    text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.",
  },
  {
    icon: aboutCardIcon1,
    title: "Gamming NFTs",
    text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.",
  },
  {
    icon: aboutCardIcon2,
    title: "Play to Earn",
    text: 'Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original.',
  },
  {
    icon: aboutCardIcon3,
    title: "Metaverse Ready",
    text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.",
  },
];

export default data;
